import React, { useRef, useEffect } from 'react';
import SectionTitle from '../../content/SectionTitle';
import { SelectOption } from '../../../types/common';
import { AddressFormData } from '../../../types/Address';
import AddressFormWithButtons from '../AddressFormWithButtons';
import InternalLink from '../InternalLink';
import FormErrorLabel from '../FormErrorLabel';
import { useMst } from '../../../models/stores/Root';

export const AddNewAddressFormTestId = 'AddNewAddressForm-input';

export type AddNewAddressFormProps = {
  countryOptions: SelectOption[];
  defaultCountry: string;
  title: string;
  isShippingAddress: boolean;
  hasAddressErrors: boolean;
  showProgress?: boolean;
  buttonText?: string;
  getStateOptions: (country: string) => {
    options: SelectOption[];
    label: string;
  };
  onErrorStatus?: (hasErrors: boolean) => void;
  onAddressSaved: (address: AddressFormData) => Promise<void>;
  onCancel: () => void;
};

const AddNewAddressForm: React.FC<AddNewAddressFormProps> = ({
  title,
  countryOptions,
  defaultCountry,
  isShippingAddress,
  buttonText = 'Continue',
  showProgress = false,
  getStateOptions,
  onErrorStatus,
  onAddressSaved,
  onCancel,
}: AddNewAddressFormProps) => {
  const outerDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    outerDivRef.current?.scrollIntoView?.();
  }, []);

  const handleSaveClick = async (address: AddressFormData): Promise<void> => {
    await onAddressSaved(address);
  };
  const rootStore = useMst();
  const { cart, configuration } = rootStore;
  return (
    <div
      className="px-2 flex flex-col"
      data-testid={AddNewAddressFormTestId}
      ref={outerDivRef}
    >
      <div className="text-xs">
        {cart.billingAddress.id ? (
          <InternalLink onClick={onCancel}>Go back</InternalLink>
        ) : (
          <FormErrorLabel
            errors={[
              'Your account does not have an address saved.',
              'Please choose or add a new address to continue.',
            ]}
          />
        )}
      </div>
      <SectionTitle>{title}</SectionTitle>
      <AddressFormWithButtons
        isShippingAddress={isShippingAddress}
        countryOptions={countryOptions}
        defaultValues={{ country: defaultCountry, residential: true }}
        getStateConfig={getStateOptions}
        onSubmitClicked={handleSaveClick}
        onErrorStatus={onErrorStatus}
        isSaving={showProgress}
        submitButtonText={buttonText}
        shippingRatesAddressType={
          configuration.features.shippingRatesAddressType
        }
      />
    </div>
  );
};

export default AddNewAddressForm;
